import { Tooltip } from 'antd';

const TopSection = (props) => {
    const { productOrderData, totalProductSale, totalDiscount } = props;

    return (
        <div className="container-fluid mt-3">
            <div className="row porduct_report_colom_set">
                <div className="col-lg-5 col-md-12">
                    <div className="left_content_product_report mb-2">
                        <div className="left-content-card">
                            <img src="https://jaipurtouch.com/public/assets/back-end/img/cart.svg" alt="" />
                            <div className="info">
                                <h4 className="subtitle">{productOrderData?.length}</h4>
                                <h6 className="subtext">Total Product</h6>
                            </div>
                        </div>
                        <div className="coupon__discount mt-0">
                            <div className="text-center">
                                <strong className="text-danger">1</strong>
                                <div className="Canceled_inner">
                                    <span>Rejected</span>
                                </div>
                            </div>
                            <div className="text-center">
                                <strong className="text-primary">4</strong>
                                <div className="Canceled_inner">
                                    <span>Pending</span>

                                </div>
                            </div>
                            <div className="text-center">
                                <strong className="text-success">4</strong>
                                <div className="Canceled_inner">
                                    <span>Active</span>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="left_content_product_report mb-2">
                        <div className="left-content-card">
                            <img src="https://jaipurtouch.com/public/assets/back-end/img/products.svg" alt="" />
                            <div className="info">
                                <h4 className="subtitle">₹{totalProductSale.toFixed(2)}</h4>
                                <h6 className="subtext">Total Product Sale</h6>
                            </div>
                        </div>
                    </div>
                    <div className="left_content_product_report">
                        <div className="left-content-card">
                            <img src="https://jaipurtouch.com/public/assets/back-end/img/stores.svg" alt="" />
                            <div className="info">
                                <h4 className="subtitle">₹{totalDiscount || 0}</h4>
                                <div className="Canceled_inner">
                                    <h6 className="subtext">Total Discount Given</h6>
                                    <Tooltip placement="top" title='Product wise discounted amount will be shown here' >
                                        <img className="info-img" src="https://jaipurtouch.com/public/assets/back-end/img/info-circle.svg" alt="img" />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-7 col-md-12 mt-2">
                    <div className="product_report_right_side">
                        <div className="product_report_right_side_hedding">
                            <h3>Product Statistics</h3>
                            <span className="ml-2" >
                                <img className="info-img" src="https://jaipurtouch.com/public/assets/back-end/img/info-circle.svg" alt="img" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopSection;